/* 类似于信息流的推荐位 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { NewsStream } from '@ifeng/news-stream';
import '@ifeng/news-stream/lib/NewsStream/style/news-stream-global.css';

class NewsStreamComponent extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return <NewsStream content={content} isEnd={true} isDisplayLoadingMore={false} />;
    }
}

export default errorBoundary(NewsStreamComponent);
